export default {
  release: '16.9',
  date: 'February 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-9-released/#this-months-notable-contributor',
  contributors: [
    {
      name: 'Ravi Dharmawan',
      gitlabUsername: 'ravi.dharmawan',
    },
    {
      name: 'Ian Walker',
      gitlabUsername: 'iwalker',
    },
  ],
  writeUp: `Ravi is actively working with GitLab's Vulnerability Research group
to address high false-positive results in [GitLab SAST.](https://gitlab.com/gitlab-org/security-products/sast-rules)

Ravi was nominated by [Rohan Shah](https://gitlab.com/rmsrohan), Customer Success Manager at GitLab, who noted
Ravi's significant improvements to the [detection rules](https://docs.gitlab.com/ee/user/application_security/sast/rules.html) used in GitLab SAST.
[Dinesh Bolkensteyn](https://gitlab.com/dbolkensteyn), Senior Vulnerability Researcher at GitLab, added
"Ravi's feedback is spot on, directly actionable and enabled us to improve many of our SAST rules."

Ravi Dharmawan a.k.a ravidhr works at GoTo Group as an Information Security Architect.
He works mostly on handling secure design review, source code review, and penetration testing.
Ravi is OSCP + eWPTXv2 certified.

Ian is the first GitLab MVP recognized for work [supporting users on the GitLab Forum.](https://forum.gitlab.com/u/iwalker/activity)
[Michael Friedrich](https://gitlab.com/dnsmichi), Senior Developer Advocate at GitLab, and
[Fatima Sarah Khalid](https://gitlab.com/sugaroverflow), Developer Advocate at GitLab both nominated Ian
for continued efforts in helping make our forum a better place for the community by answering questions for users who are setting up and using GitLab.

Ian works at UpWare Sp. z o.o. as a System and Security Consultant, working mostly on Red Hat OpenShift and anything Linux-related.
He is Red Hat Certified RHCSA + RHCE and has been managing, maintaining and supporting his own self-hosted Gitlab installation since 2017.
Ian has been regularly active on the GitLab forums for 3+ years with 2,600+ helpful responses, 480 helpful community moderation flags, and 240 solutions.

Thank you Ravi and Ian! 🙌`,
};
